import { z } from 'zod';
import { EntityType } from '$lib/sanity/types';
import { SanityDocumentSchema } from '../sanity';
import { SEOSchema } from '../shared/SEO';

const LegalCollectionPageHeader = z.object({
  title: z.string()
});

const LegalLinkSchema = z.object({
  copy: z.string(),
  type: z.literal('url').or(z.literal('page')).nullish(),
  url: z.string().nullish(),
  page: z
    .discriminatedUnion('_type', [
      z.object({
        _type: z.literal(EntityType.LegalPage),
        slug: z.string()
      }),
      z.object({ _type: z.literal(EntityType.LegalLicensesPage) })
    ])
    .nullish(),
  languageGroup: z.string().optional()
});

const LegalCountrySchema = z.object({
  name: z.string(),
  links: z.array(LegalLinkSchema)
});

export const LegalLandingPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.LegalLandingPage),
  header: LegalCollectionPageHeader,
  seoAttributes: SEOSchema.nullish(),
  publishedDate: z.string().nullish(),
  countries: z.array(LegalCountrySchema)
});

export type LegalLandingPage = z.infer<typeof LegalLandingPageSchema>;
export type LegalCountry = z.infer<typeof LegalCountrySchema>;
export type LegalLink = z.infer<typeof LegalLinkSchema>;
